import { z } from 'zod';
/**
 * Dinamik form alan tipleri.
 * Eski karşılıkları: lib/araclar/alanadd/{metinw,secimw,coklusecim,barkodw,resimw}.dart
 */
export const fieldTypeSchema = z.enum([
    'text',
    'number',
    'select',
    'multiselect',
    'barcode',
    'image',
    'location',
]);
export const formFieldSchema = z.object({
    id: z.string().uuid(),
    label: z.string(),
    type: fieldTypeSchema,
    /** select / multiselect için seçenekler; diğer tiplerde boş. */
    options: z.array(z.string()).default([]),
    isRequired: z.boolean(),
    sortOrder: z.number().int(),
});
export const formTemplateSchema = z.object({
    id: z.string().uuid(),
    tenantId: z.string().uuid(),
    name: z.string(),
    fields: z.array(formFieldSchema),
});
/**
 * Bir form şablonundan çalışma anında zod şeması üretir.
 * Aynı fonksiyon hem sunucuda (kayıt doğrulama) hem client'ta (form doğrulama)
 * kullanılır — kurallar tek yerde tanımlı kalır.
 */
export function buildRecordDataSchema(fields) {
    const shape = {};
    for (const field of fields) {
        let schema;
        switch (field.type) {
            case 'number':
                schema = z.number();
                break;
            case 'multiselect':
                schema = z.array(z.enum(field.options));
                break;
            case 'select':
                schema = field.options.length
                    ? z.enum(field.options)
                    : z.string();
                break;
            case 'image':
                // Yüklenmiş dosyaların yol listesi.
                schema = z.array(z.string());
                break;
            case 'location':
                schema = z.object({ lat: z.number(), lng: z.number() });
                break;
            case 'text':
            case 'barcode':
                schema = z.string();
                break;
        }
        shape[field.id] = field.isRequired ? schema : schema.optional();
    }
    return z.object(shape);
}
//# sourceMappingURL=form.js.map